
  export default {
    components: {
      RegistrationOrLoginDialog: () =>
        import('@/components/candidate/RegistrationOrLoginDialog'),
      SearchPopoverMenu: () => import('@/components/SearchPopoverMenu'),
    },
    props: {
      drawer: {
        type: Boolean,
        default: undefined,
      },
    },
    data() {
      return {
        menu: false,
        overlay: false,
        logoUrl: require(process.env.NUXT_ENV_FALLBACK_LOGO),
      };
    },
    methods: {
      toggleDrawer() {
        this.$emit('toggle-drawer');
      },
      togglePopupMenu(event) {
        this.menu = event.menu;
        this.overlay = event.overlay;
      },
    },
  };
